import { useTranslation } from 'react-i18next';
import { ResourceCrudPage, type ResourceListArgs, type PaginatedResult } from '@vipso/shared';
import {
  useListLabourQuery,
  useAddUpdateLabourMutation,
  useDeleteLabourMutation,
} from '../api/enhanceGenerated';
import { useAccess } from '../hooks/useAccess';

type LabourRow = { id: string; name: string; phone?: string };

function useLabourList(args: ResourceListArgs) {
  const result = useListLabourQuery(args);
  const data: PaginatedResult<LabourRow> | undefined = result.data?.listLabour
    ? {
        ...result.data.listLabour,
        rows: result.data.listLabour.rows.map((r) => ({
          id: r.id,
          name: r.name,
          phone: r.phone ?? undefined,
        })),
      }
    : undefined;
  return { ...result, data };
}

export function LabourPage() {
  const { t } = useTranslation();
  const { canMutate } = useAccess();
  const [save, { isLoading: saving }] = useAddUpdateLabourMutation();
  const [remove] = useDeleteLabourMutation();

  return (
    <ResourceCrudPage<LabourRow>
      title={t('nav.labour')}
      description={t('labour.description')}
      entityLabel={t('labour.entity')}
      entityLabelPlural={t('labour.entityPlural')}
      canMutate={canMutate()}
      saving={saving}
      useList={useLabourList}
      fields={[
        { key: 'name', label: t('common.name'), required: true },
        { key: 'phone', label: t('common.phone') },
      ]}
      onSave={(values, editing) =>
        save({ input: { ...values, id: editing?.id } }).unwrap()
      }
      onDelete={(row) => remove({ id: row.id }).unwrap()}
    />
  );
}
